import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { CornerBadge } from '../../Components/PuzzleNav/components/CornerBadge';
import { usePathMatch } from '../../Components/PuzzleNav/hooks';
import { TabWrapper, Title } from './styled';
export const NavigationItem = memo(function NavigationItem({ title, exact, path, to, dataTestId = `nav-tab-${to}`, hidden, isNew, }) {
    const match = usePathMatch({ path: path ?? to, exact });
    if (hidden) {
        return null;
    }
    return (_jsxs(TabWrapper, { to: to, as: NavLink, "$active": match, "data-testid": dataTestId, children: [isNew && _jsx(CornerBadge, { variant: 'new' }), _jsx(Title, { "$active": match, children: title })] }));
});
